import Link from "next/link";
import type { ReactNode } from "react";

export default function ServiceCard({
  icon,
  title,
  description,
  href,
  items
}: {
  icon: ReactNode;
  title: string;
  description: string;
  href?: string;
  items?: string[];
}) {
  return (
    <div className="flex h-full flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_12px_32px_-24px_rgba(15,23,42,0.42)] transition duration-300 focus-within:border-slate-300 focus-within:shadow-[0_24px_50px_-28px_rgba(15,23,42,0.45)] sm:p-6">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand text-gray-950">
        {icon}
      </div>
      <div>
        <h3 className="text-xl font-semibold leading-snug text-gray-950">{title}</h3>
        <p className="mt-2.5 text-[0.95rem] leading-7 text-slate-600">{description}</p>
      </div>
      {items && (
        <ul className="mt-0.5 space-y-2 border-t border-slate-100 pt-4 text-[0.95rem] leading-7 text-slate-600">
          {items.map((item) => (
            <li key={item} className="flex items-start gap-2">
              <span className="mt-[0.2rem] text-gray-950">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
      {href && (
        <Link
          href={href}
          className="mt-auto inline-flex min-h-11 w-fit items-center gap-2 rounded-sm pt-1 text-sm font-semibold text-gray-950 transition hover:gap-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-4"
        >
          ดูรายละเอียดบริการ
          <span aria-hidden>→</span>
        </Link>
      )}
    </div>
  );
}
